import { PriceTierListResponseType } from "@sellar-io/api-v2/types";

type PriceTier = PriceTierListResponseType[number];
type PriceTierOrderRules = Pick<
  PriceTier,
  "PriceTierOrderRules"
>["PriceTierOrderRules"];

export const filterOrderRulesWithContainerType = ({
  orderRules,
  containerType,
}: {
  orderRules: PriceTierOrderRules;
  containerType: "bottle" | "can";
}) => {
  return orderRules.filter(
    (rule) => containerType === rule.itemType || rule.itemType === "any",
  );
};

export const getPriceTiersWithOrderRuleContainerType = ({
  priceTierList,
  containerType,
}: {
  priceTierList: PriceTier[];
  containerType: "bottle" | "can";
}) => {
  return priceTierList
    .filter((priceTier) => {
      return !!filterOrderRulesWithContainerType({
        orderRules: priceTier.PriceTierOrderRules,
        containerType,
      }).length;
    })
    .map((priceTier) => {
      const priceTierDiscounts = filterOrderRulesWithContainerType({
        orderRules: priceTier.PriceTierOrderRules,
        containerType,
      });

      return {
        id: priceTier.id,
        name: priceTier.name,
        PriceTierDiscounts: priceTierDiscounts,
      };
    });
};
